<template>
  <div class="text-center" v-show="isLoading">
    <v-overlay>
      <div class="text-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
    </v-overlay>
  </div>
</template>
<script>
export default {
  props: {
    setLoading: {
      default: function() {
        return {
          loading: false,
        };
      },
      type: Object,
    },
  },
  methods: {
    show: function() {
      this.$emit('showLoading');
    },
    hide: function() {
      this.$emit('hideLoading');
    },
  },
  computed: {
    isLoading: function() {
      return this.setLoading.loading;
    },
  },
};
</script>
<style scoped>
.v-progress-circular {
  margin: 1rem;
}

.v-overlay.v-overlay--active.theme--dark {
  z-index: 203 !important;
}
</style>
